
    import {Component, EventEmitter, Output, OnInit} from '@angular/core';
    import {AuthService} from '../../../../services/auth.service';
    import {Router} from '@angular/router';
    import {
        fadeInLeftOnEnterAnimation,
        fadeInOnEnterAnimation,
        fadeInUpBigOnEnterAnimation,
        fadeOutOnLeaveAnimation,
        fadeOutRightOnLeaveAnimation
    } from 'angular-animations';
    import {UserService} from '../../../../services/user.service';
    import {Subscription} from 'rxjs';
    import {EventsService} from '../../../../services/events.service';
    import {environment} from '../../../../../environments/environment';
    import {AnalyticsService} from '../../../../services/analytics.service';
    import {TemplateCoachSimpleModel} from '../../models/coach.model';
    import {CoachService} from '../../service/coach.service';

    @Component({
        selector: 'app-coach-list',
        templateUrl: 'coach-list.component.html',
        styleUrls: ['coach-list.component.scss'],
        animations: [
            fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
            fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
            fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
            fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
            fadeInUpBigOnEnterAnimation({anchor: 'enterUp', duration: 300}),
        ],
    })

    export class CoachListComponent implements OnInit {
        subscriptions: Subscription[] = [];
        environment = null;
        menuVisible = true;
        coachesList: TemplateCoachSimpleModel[] = null;
        coachesListPromise: Promise<TemplateCoachSimpleModel[]> = null;
        coachesListValid = true;
        platform = 'website';
        coachGroups: any[] = [];
        opened: boolean;

        isShowMatched = false;

        @Output() gotoCalendarEvent = new EventEmitter();
        @Output() gotoProfileEvent = new EventEmitter();

        constructor(
            private event: EventsService,
            public authService: AuthService,
            private userService: UserService,
            private analytics: AnalyticsService,
            private coachService: CoachService,
            private router: Router,
        ) {
            this.environment = environment;
        }

        async ngOnInit() {
            this.platform = environment.platform;
            this.coachesList = await this.coachService.getMyCoachesList();
        }

        ionViewWillEnter() {
            this.menuVisible = false;

            if (this.coachesList === null || !this.coachesListValid) {
                this.coachesListPromise = this.coachService.getMyCoachesList();
            }
        }
        gotoCalendar(event){
            this.gotoCalendarEvent.emit(event);
        }
        gotoProfile(event){
            this.gotoProfileEvent.emit(event);
        }
        ionViewDidEnter() {
            this.analytics.trackView('Coach Profiles and Calendars');

            if (this.coachesList === null || !this.coachesListValid) {
                this.coachesListPromise.then(data => {
                    this.coachesList = data;
                    this.coachesList.forEach(item => item.groups.forEach(group => {
                        const element = this.coachGroups.find(x => x.id === group.id);
                        if (!element) {
                            group['selected'] = true;
                            group['count'] = 1;
                            this.coachGroups.push(group);
                        }
                        else {
                            ++element.count;
                        }

                    }))
                    this.coachGroups.sort(function(a, b) {
                        if (a.id < b.id) {
                            return -1;
                        }
                        if (a.id > b.id) {
                            return 1;
                        }
                    })
                    this.coachesListValid = true;
                });
            }
        }

        // coachGroupSelected(coach: TemplateCoachSimpleModel) {
        //     if (!this.coachGroups || !this.coachGroups.length) {
        //         return true;
        //     }
        //     let result = false;
        //     const selectedGroups = this.coachGroups.map(item => {if (item.selected) {return item.id}});
        //     coach.groups.forEach(item => {
        //         if (selectedGroups.includes(item.id)) {
        //             result = true;
        //         }
        //     }
        //     )
        //     return result;
        // }
    }
